var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYouTube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264:16823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0767 2.12275C10.674 1.95875 5.32267 1.95942 2.92333 2.12275C0.325333 2.30008 0.0193333 3.86942 0 8.00008C0.0193333 12.1234 0.322667 13.6994 2.92333 13.8774C5.32333 14.0408 10.674 14.0414 13.0767 13.8774C15.6747 13.7001 15.9807 12.1308 16 8.00008C15.9807 3.87675 15.6773 2.30075 13.0767 2.12275V2.12275ZM6 10.6668V5.33342L11.3333 7.99542L6 10.6668V10.6668Z",
    fill: "#030303"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264:16823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

export default SvgYouTube;